import * as CookieConsent from "vanilla-cookieconsent";

function loadGTM() {
  if (window._gtmLoaded) return;
  window._gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const f = document.getElementsByTagName("script")[0];
  const j = document.createElement("script");
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-5QKDKNW";
  f.parentNode.insertBefore(j, f);
}

function loadClarity() {
  if (window._clarityLoaded) return;
  window._clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "wc6ep0h7mr");
}

CookieConsent.run({
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: /^_ga/ },
          { name: "_gid" },
          { name: /^_clsk/ },
          { name: "_clck" },
          { name: "CLID" },
        ],
      },
    },
  },

  onConsent: () => {
    if (CookieConsent.acceptedCategory("analytics")) {
      loadGTM();
      loadClarity();
    }
  },

  onChange: ({ changedCategories }) => {
    if (changedCategories.includes("analytics")) {
      if (CookieConsent.acceptedCategory("analytics")) {
        loadGTM();
        loadClarity();
      }
    }
  },

  language: {
    default: "de",
    translations: {
      de: {
        consentModal: {
          title: "Wir nutzen Cookies",
          description:
            "Diese Website verwendet Cookies zur Nutzungsanalyse und Verbesserung des Nutzererlebnisses. Mit 'Alle akzeptieren' stimmen Sie der Verwendung aller Cookies zu.",
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Nur notwendige",
          showPreferencesBtn: "Einstellungen",
          footer:
            '<a href="/datenschutz">Datenschutz</a> &nbsp;|&nbsp; <a href="/impressum">Impressum</a>',
        },
        preferencesModal: {
          title: "Cookie-Einstellungen",
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Nur notwendige",
          savePreferencesBtn: "Einstellungen speichern",
          closeIconLabel: "Schließen",
          sections: [
            {
              title: "Notwendige Cookies",
              description:
                "Diese Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.",
              linkedCategory: "necessary",
            },
            {
              title: "Analyse-Cookies",
              description:
                "Diese Cookies helfen uns zu verstehen, wie Besucher unsere Website nutzen. Wir setzen Google Tag Manager und Microsoft Clarity zur Analyse des Nutzerverhaltens ein.",
              linkedCategory: "analytics",
              cookieTable: {
                headers: {
                  name: "Cookie",
                  domain: "Domain",
                  desc: "Beschreibung",
                },
                body: [
                  {
                    name: "_ga",
                    domain: "google.com",
                    desc: "Google Analytics – unterscheidet Nutzer (2 Jahre)",
                  },
                  {
                    name: "_gid",
                    domain: "google.com",
                    desc: "Google Analytics – speichert Sitzungsinfos (24h)",
                  },
                  {
                    name: "_clsk",
                    domain: "clarity.ms",
                    desc: "Microsoft Clarity – fasst Seitenaufrufe zusammen (1 Tag)",
                  },
                  {
                    name: "_clck",
                    domain: "clarity.ms",
                    desc: "Microsoft Clarity – identifiziert Browser-Sitzung (1 Jahr)",
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
});

export default CookieConsent;
